<template>
  <v-ons-page>

    <!-- <v-ons-modal :visible="modalVisible" @click="modalVisible = false"> -->
    <v-ons-modal :visible="modalVisible">
      <div class="header">
        <img src="../assets/lasmeru-logo-bold.png" width="240" height="80">
      </div>
      <p style="text-align: center">
        ver {{this.appVersion}}<br><br>
        Loading...<v-ons-icon icon="fa-spinner" spin></v-ons-icon>
      </p>
    </v-ons-modal>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import common from '../util/common'
import comLic from '../util/com_license'

export default {
  name: 'DefaultComponent',
  mixins: [common, comLic],
  data () {
    return {
      modalVisible: true,
      itemAccount: {link: 'AccountRoot', anim: 'slide'},
      isLogin: false,
      isOperation: false,
      isUserReady: false,
      isReadyToStart: false,
      isLicenseReady: false,
      services: {},
      fcmToken: '',
      majorVersion: 1,
      minorVersion: 0,
      microVersion: 0,
      curVersion: 100,
      devRoot: false
    }
  },

  created () {
    // console.log('Created DefaultComponent')
    this.$store.commit('appVersion/set', this.majorVersion + '.' + this.minorVersion + '.' + this.microVersion)
    this.loginFirebase()
  },

  mounted () {
    // console.log('Mounted DefaultComponent')
  },

  computed: {
  },

  watch: {
    isLogin: function () {
      this.getOperations()
    },
    isOperation: function () {
      this.getUserfromDB()
    },
    isUserReady: function () {
      // firebaseにログインするまでWatchして、profileを取りに行く。
      this.isReadyToStart = true
    },
    isReadyToStart: async function () {
      // 最初のselectedSchool === 0 のメインタブバッジを読み出してストアに入れておく。
      // let sbuf = localStorage.getItem(this.schools[0].sid + '-msg-badge')
      // if ((sbuf === null) || (sbuf === undefined)) {
      //   sbuf = ''
      // }
      // this.$store.commit('tabBadgeMessage/set', String(sbuf))

      // ログインとプロファイルのStoreまで完了してからアプリトップへ遷移する。
      // this.cordovaInitFCM()
      let licensense = await this.getLicense()
      if (licensense === false) {
        // console.log('License has not ready yet', licensense)
        const self = this
        const db = firebase.firestore()
        db.collection('/license').doc(this.account.uid).onSnapshot((doc) => {
          let val = doc.data()
          // console.log('onSnapshot Lic', val)
          if ((val !== undefined) && (val !== null)) {
            self.$store.commit('lic/set', val)
            self.isLicReady = true
            self.isLicenseReady = true
          }
        })
      } else {
        // console.log('Lic Ready')
        this.modalVisible = false
        this.$router.push('AppView')
      }
    },
    isLicenseReady: async function () {
      // console.log('Lic Ready11111')
      this.modalVisible = false
      this.$router.push('AppView')
    }
  },

  methods: {
    // cordovaInitFCM: function () {
    //   // Webだと直ちにREADY, CORDOVAだと準備出来てからREADYになる。
    //   var self = this

    //   this.$ons.ready(function () {
    //     console.log('*** Device Ready ***')
    //     if (self.$ons.isWebView()) {
    //       // console.log('Corodova Run')
    //       // window.FCMPlugin.onTokenRefresh(function (token) {
    //       window.FCMPlugin.getToken(function (token) {
    //         // console.log('*** Get Token: ', token)
    //         self.fcmToken = token
    //         self.fcmTokenInit()
    //       })
    //       window.FCMPlugin.onTokenRefresh(function (token) {
    //         // console.log('*** Refreshed Token: ', token)
    //         self.fcmToken = token
    //         self.fcmTokenInit()
    //       })
    //       window.FCMPlugin.onNotification(function (data) {
    //         // 当面は、通知をタップしようがしまいが、AppViewを起動するようにしておく。
    //         // じゃないと、戻るボタンがヒストリバックできなかったりめんどそうだから。
    //         // 代りに、バッジをちゃんとONにして新着を分からせる。
    //         if (data.wasTapped) {
    //           // Notification was received on device tray and tapped by the user.
    //           // console.log('data.wasTapped True', JSON.stringify(data))
    //         } else {
    //           // Notification was received in foreground. Maybe the user needs to be notified.
    //           // console.log('data.wasTapped False', JSON.stringify(data))
    //           // data.wasTapped False {"wasTapped":false,"title":"通知 ０５１９ ０１","body":"データも渡してみる","TESTKEY":"TESTVALUE"}
    //           if (data.title === undefined) {
    //             // IOS は構造が少し変わっちゃうんで
    //             // data.wasTapped False {"schoolId":"MzPAUsxJ3g2MqIBWOjrD","itemId":"udkIPzOLAJy0zAOwHQxk","gcm.message_id":"0:1559449130049919%f1574110f1574110","google.c.a.e":"1","category":"event","aps":{"alert":{"title":"マイリー小学校 イベント登録「イベント0603
    //             self.$ons.notification.toast('新着通知: ' + data.aps.alert.title, { timeout: 2000, animation: 'fall' })
    //           } else {
    //             // Androidはこれで取れる。
    //             self.$ons.notification.toast('新着通知: ' + data.title, { timeout: 2000, animation: 'fall' })
    //           }
    //         }
    //         // バッジ処理
    //         // AppViewのコンポーネントは起動時にGetしてバッジ出すので何もしない.
    //         // サイドメニューの奴らはバッジ出さないと誘導できないので出す。
    //         // console.log('data.category: ', data.category)
    //         // if (data.category === 'chats') {
    //         //   // console.log('data.schoolId: ', data.schoolId)
    //         //   // console.log('data.itemId: ', data.itemId)
    //         //   let tempRooms = self.$store.state.notifiedChatRooms.rooms
    //         //   tempRooms.push({schoolId: data.schoolId, roomId: data.itemId})
    //         //   self.$store.commit('notifiedChatRooms/set', tempRooms)
    //         //   self.$store.commit('tabBadgeChat/set', '!')
    //         // }
    //       },
    //       function (data) {
    //         console.log('FCMPlugin onNotification Success')
    //       },
    //       function (data) {
    //         console.log('FCMPlugin onNotification Error')
    //       })
    //     } else {
    //       console.log('Not Cordova')
    //     }
    //   })
    // },
    // fcmTokenInit () {
    //   // fcmトークンを取得して、FireStoreに保存して、ローカルにキャッシュ。
    //   // ２回目以降は、ゲットしたトークンをキャッシュしてたのと比べて違ってたらFireStoreに送って更新。
    //   // user.fcmToken としてuserのdocに保存したいので、userが作られて取得できた時に保存する。
    //   var self = this
    //   var cachedToken = ''
    //   const userRef = firebase.firestore().collection('/users')

    //   if ((this.fcmToken !== null) && (this.fcmToken !== undefined) && (this.fcmToken !== '')) {
    //     cachedToken = localStorage.getItem('fcmToken-' + this.account.uid)
    //     if (this.fcmToken !== cachedToken) {
    //       // ここでuser.fcmToken としてDBにセットしてから、ローカルストアとストレージに保存する
    //       userRef.doc(this.account.uid).update({fcmToken: this.fcmToken})
    //       .then(function () {
    //         // self.updateMemberToken(self.fcmToken)
    //         localStorage.setItem('fcmToken-' + self.account.uid, self.fcmToken)
    //         console.log('fcmTokenInit Set/Update token to LocalStorage')
    //       })
    //       .catch(function (error) {
    //         console.log('fcmTokenInit update token error:, ', error)
    //       })
    //     } else {
    //       console.log('fcmTokenInit No Update: ', this.fcmToken)
    //     }
    //   } else {
    //     console.log('fcmTokenInit Token NULL: ', this.fcmToken)
    //     localStorage.setItem('fcmToken-' + this.account.uid, '')
    //   }
    // },

    loginFirebase: function () {
      var self = this
      // firebase.auth().signInAnonymously()
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          self.account = user
          // User is signed in.
          // console.log('is login.', user)
          self.isLogin = true
        } else {
          // No user is signed in.
          self.$ons.notification.alert('サインインが必要です！')
          console.log('No user is signed in.')
          self.$router.push('InitialStart')
          // self.$router.push('ModeSelect')
        }
      })
    },

    getOperations () {
      // ーーーーーーーー 運営状況の確認 －－－－－－－－－－－
      // firebaseのDBにoperationsフラグを持たせて、アプリ起動時にチェックさせる。
      // これにより、運転中、メンテ中の判定を行う。メンテ中の場合はメッセージを出して先に進まないようにする。
      const operationsRef = firebase.firestore().collection('/operations')
      var self = this
      const version = this.curVersion

      let mileyInfoLastUpdate = Number(localStorage.getItem('mileyInfo-lastUpdate'))
      if ((mileyInfoLastUpdate === null) || (mileyInfoLastUpdate === undefined)) {
        mileyInfoLastUpdate = 0
      }

      console.log('getOperations')
      operationsRef.doc('services').get()
        .then(doc => {
          // console.log('snapshot =', snapshot)
          if (!doc.exists) {
            self.$ons.notification.alert('サービス稼働状況が不明です！')
            self.$router.push({name: 'ErrorSuspend', params: {errIndex: 0}})
          } else {
            self.services = doc.data()
            if (self.services.isRunning === false) {
              // メンテ中なのでエラー表示して処理を止める。
              self.$ons.notification.alert('サービス停止中です！しばらく時間をあけてからリトライしてみてください。')
              self.$router.push({name: 'ErrorSuspend', params: {errIndex: 0}})
            } else {
              // if (self.services.infoUpdate > mileyInfoLastUpdate) {
              //   this.$store.commit('mileyInfoUpdateFlag/set', true)
              //   // localStorage.setItem('mileyInfo-lastUpdate', JSON.stringify(mileyInfoLastUpdate))
              // } else {
              //   this.$store.commit('mileyInfoUpdateFlag/set', false)
              // }

              if (version < this.services.requiredVersion) {
                // self.$ons.notification.alert('アプリの更新が必要です！最新版をインストールしてください。')
                self.$router.push({name: 'ErrorSuspend', params: {errIndex: 1}})
              } else {
                self.isOperation = true
              }
            }
          }
        })
        .catch(err => {
          console.log('Error getting services', err)
        })
    },

    getUserfromDB: function () {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.account.uid)
      let userTemp = {}

      this.user = JSON.parse(localStorage.getItem('user' + this.account.uid))
      // console.log('GET User: ', this.user)
      if ((this.user === null) || (this.user === undefined)) {
        // console.log('GET User: ', this.account.uid)
        userRef.get()
          .then(function (doc) {
            if (doc.exists) {
              userTemp = doc.data()
              self.user = userTemp
              localStorage.setItem('user' + self.user.userId, JSON.stringify(self.user))
              self.isUserReady = true
            } else {
              // console.log('No User!')
              // ログインできてかつ、userがローカルにもDBにも無いケース、初回User登録直後のリブート
              // ローカルにセーブ
              let newUser = {
                userId: self.account.uid,
                fcmToken: '',
                version: 1, // このドキュメント構造のバージョン
                timeStamp: self.timestamp() // createdAt
              }
              userRef.set(newUser)
              // DBにセット
              console.log('SET newUser OK')
              localStorage.setItem('user' + newUser.userId, JSON.stringify(newUser))
              self.user = newUser

              self.$ons.notification.toast('アカウント情報を登録しました！', { timeout: 2000, animation: 'fall' })
              // self.$ons.notification.toast('次はプロフィール情報の設定を行いましょう！', { timeout: 2000, animation: 'fall' })

              // self.$router.push('AccountRoot')
              self.isUserReady = true
            }
          }).catch(function (error) {
            self.$ons.notification.alert('UserGetエラー: ' + error)
            console.log('Error GET User:', error)
          })
      } else {
        self.isUserReady = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  text-align: center;
}

img {
  max-width: 300px;
}

ons-list-title {
  text-transform: none;
}

ons-list-title:not(:first-of-type) {
  margin-top: 30px;
}

ons-card {
  text-align: center;
}

ons-list-item, ons-card {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultComponent.vue